import i18n from '../i18n/i18n'
import { toast } from 'react-toastify'

const showToastError = (errorMessage) => {
	toast.error(errorMessage || i18n.t('api.error'))
}

export default showToastError
